// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wTQT","right":"styles_right__h8Icu"};